var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M277.3,263.4c0,9.5-0.2,18.4,0.2,27.2c0.1,1.3,2.8,3.1,4.5,3.5c26.3,6.7,47.5,20.9,63.8,42.6c37.7,50.1,23.5,125-30,157.8 c-55.4,34-123.6,17.2-156.7-38.7c-9.8-16.5-14.2-34.7-14.4-53.8c-0.1-11.9,9-21.2,20.5-21.5c12.1-0.4,21.6,8,22.1,20.2 c1.1,25.7,11.7,45.9,34,59.3c23.9,14.4,54.4,12.2,76.9-5.2c21.6-16.7,30.7-45.4,23-72.1c-7.6-26.2-30.9-45.6-58.3-48.3 c-2.4-0.2-4.9-0.4-7.3-0.6c-13-1-21.1-9.3-21.2-22.4c-0.2-15.7,0-31.3,0-47.8c-2,0-3.8,0-5.7,0c-24.7,0-49.5,0-74.2,0 c-14.6,0-22.8-7-24.3-21.6c-3.1-30.8-5.8-61.7-8.8-92.5c-3.3-35.5-6.7-71-10-106.6c-0.7-7.1-1.5-14.2-1.6-21.3 C109.6,9.6,118.6,0.5,130.4,0c1.2-0.1,2.4,0,3.7,0c81,0,162,0,243,0c2.6,0,5.2,0.2,7.8,0.7c11.3,2.1,18.4,11.6,17.3,23 C396.4,83.9,390.7,144,385,204.1c-1.2,12.5-2.3,25-3.4,37.4c-1.2,13.8-9.7,21.8-23.7,21.8c-24.7,0.1-49.5,0-74.2,0 C281.9,263.4,280,263.4,277.3,263.4z M171.3,220.3c56.8,0,112.8,0,169.1,0c5.6-59.3,11.1-118.2,16.7-177.2c-67.9,0-135,0-202.4,0 C160.3,102.4,165.8,161.3,171.3,220.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinders);
export default __webpack_public_path__ + "static/media/binders.1ccabbeae5e06d8cd9b0cd7d71873a98.svg";
export { ForwardRef as ReactComponent };